import "./App.css";
import "./styles/components.css";
import { Routes, Route, useNavigate } from "react-router-dom";
import Quote from "./pages/Quote";
import CompletedPage from "./pages/CompletedPage";
import Admin from "./pages/Admin";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Quote />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/quote/complete" element={<CompletedPage />} />
      </Routes>
    </div>
  );
}

export default App;

const StartPage = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        flexDirection: "column",
        gap: "2rem",
      }}
      className="flex_center"
    >
      <button
        className="primary_btn"
        onClick={() => {
          navigate("/quote");
        }}
      >
        Apply to be a Brokers{" "}
      </button>
      <p>OR</p>
      <button
        className="secondary_btn"
        onClick={() => {
          // navigate("/trailer");
        }}
      >
        Broker Login{" "}
      </button>
    </div>
  );
};
